import { Box, Typography } from '@mui/material';

/** "Cadence" wordmark — no logo asset, just typeset Inter at a tighter tracking. */
export function Wordmark({ compact = false }: { compact?: boolean }) {
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>
      <Box
        aria-hidden
        sx={(theme) => ({
          width: 24,
          height: 24,
          borderRadius: 1,
          bgcolor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 700,
          fontSize: 14,
        })}
      >
        C
      </Box>
      {!compact && (
        <Typography
          variant="h6"
          sx={{ fontWeight: 600, letterSpacing: '-0.02em', lineHeight: 1 }}
        >
          Cadence
        </Typography>
      )}
    </Box>
  );
}
